import { createContext } from 'react';
import { ActivityAnalyticsItem } from '@/api';

export interface TasksAndAlertsTeamActivityContextData {
    status: 'error' | 'success' | 'pending';
    activity: ActivityAnalyticsItem[];
    dateString: string | null;
}

export const TasksAndAlertsTeamActivityContext = createContext<
    TasksAndAlertsTeamActivityContextData | undefined
>(undefined);
